import { Stack } from 'expo-router';

export default function AdminBroadcastsTabLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
